import * as React from 'react';

export interface IInputControlContext {
  error: boolean;
  ariaDescribedby: string;
}

export const InputControlContext: React.Context<IInputControlContext> =
  React.createContext<IInputControlContext>({ error: false, ariaDescribedby: '' });

export const useInputControlContext = () => React.useContext(InputControlContext);
